export default __webpack_public_path__ + "static/media/General_02.4bb39ed5.jpg";